// extracted by mini-css-extract-plugin
export var originalPrice = "_vm-0";